import NextPageButton from '@components/next-page-button/NextPageButton';
import Pagination from '@components/pagination/Pagination';
import PreviousPageButton from '@components/previous-page-button/PreviousPageButton';
import { PAGINATION_LIMIT } from '@constants/generic';

interface TablePageIndicatorProps {
  currentPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  limit?: number;
  className?: string;
}

const TablePageIndicator = ({
  currentPage,
  totalCount,
  onPageChange,
  limit = PAGINATION_LIMIT,
  className
}: TablePageIndicatorProps) => (
  <div className={`mt-2 flex w-full items-center justify-between ${className}`}>
    <PreviousPageButton page={currentPage} setPage={onPageChange} />
    <Pagination
      page={currentPage}
      setPage={onPageChange}
      totalCount={totalCount}
      limit={limit}
    />
    <NextPageButton
      page={currentPage}
      setPage={onPageChange}
      totalCount={totalCount}
      limit={limit}
    />
  </div>
);

export default TablePageIndicator;
